import React, {Component} from 'react';
import {
    View,
    StatusBar,
    Image,
    TextInput,

    BackHandler,
    Alert,
    TouchableOpacity,
    Platform,
    KeyboardAvoidingView,
    FlatList, ScrollView
} from "react-native"

import {verticalScale, moderateScale, scale} from "../../../../tools/Scaling";

import {AsyngStorageClass} from '../../../../tools/AsyngStorageClass';
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import HMTextView from "../../../../customviews/HMTextView";
import Colors from "../../../../tools/Colors";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";
//import HMImageBackground from "../../../../customviews/HMImageBackground";
import i18n from "../../../../I18n/i18n";
//import HMTextInputEfects from "../../../../customviews/HMTextInputEfects";
import FontAwesomeIcon from 'react-native-vector-icons/dist/FontAwesome';
import store from "../../../../redux/store";
import {typeExport} from "../../../../redux/store/type";
import HMListCheckBox from "../../../../customviews/HMListCheckBox";
import HMActionBarSatia from "../../../../customviews/HMActionBarSatia";
import HMTextInput from "../../../../customviews/HMTextInput";
import HMTextInputEfects from "../../../../customviews/HMTextInputEfects";
import HMAlert from "../../../../customviews/HMAlert";

let container = null
export default class ChangeInformationSatiaScreen extends Component {
    constructor(props) {
        super(props);
        container = this;
        let {user} = store.getState().reducerSplashSatiaScreen;
        user = user.customer;
        this.state = {
            FirstName: {
                value: "",
                error: ''
            },
            LastName: {
                value: "",
                error: ''
            }
            ,
            once: true,

            phone: user.Username,
            phoneNumber: user.Mobile,
            indexSelectCheckBoxGender: user.Sex == "MR" ? 1 : 0,
            First_name: user.FName,
            Last_name: user.LName,
            NationalCode: user.ShSh,
            Education: user.detail && user.detail.Madrak ? user.detail.Madrak : null,
            Email: user.Email,
            PostalCode: user.detail && user.detail.CodePosty ? user.detail.CodePosty : null,
            address: user.detail && user.detail.Address ? user.detail.Address : null,

        }
    }

    componentWillMount() {
        this.getAsyncStorage()
    }

    componentWillReceiveProps(propss) {

    }

    getAsyncStorage = async () => {

        let token = this.props.token;
        if (token != null) {
            this.setState({
                    FirstName: {
                        // value: value.name,
                        value: this.props.user.name,
                        error: ''
                    },
                    LastName: {
                        // value: value.LastName,
                        value: this.props.user.family,
                        error: ''
                    }
                }
                ,
                () => {
                }
            )
        } else {

           // this.props.navigation.navigate("LoginEnterPhoneScreen", {type_login: "changeInfo"});
            this.props.navigation.navigate("LoginStackScreen", {type_login: "changeInfo"});
        }
    }

    async setInfoUser(user, token, LastName, name) {
        this.props.callServiceSetUser(user)
        this.props.callServiceSetWallet(user.credit, 2)
        const value = await AsyngStorageClass.setInfoUser(token, LastName, name);
        if (value) {
        } else {
            alert(i18n.t('constant.retry'))
        }
    }

    getData() {
        let paramss = {
            "_operation": typeExport._Contacts,
            "mode": "SaveTickets",
            "lang": i18n.locale,
            "token": store.getState().reducerSplashSatiaScreen.token,

            "firstname": this.state.FirstName.value,
            "lastname": this.state.LastName.value,


            //"token_fb": this.props.DataSplashScreen.token_fb,
        };
        this.props.callService(
            typeExport.urlGetChangeInformationSatiaScreen,
            //`?token=${this.state.token}&name=${this.state.name.value}&LastName=${this.state.LastName.value}`,
            //  `?name=${this.state.FirstName.value}&family=${this.state.LastName.value}`,
            paramss,
            typeExport.TypegetDataChangeInformationSatiaScreen,
            "POST",
            this.props.token
        );
    }

    checkInput() {

        let {FirstName, LastName} = this.state;

        if (FirstName.value.trim().length <= 1) {
            HMAlert(
                i18n.t('constant.message'),
                i18n.t('constant.EnterYourNameCorrectly'),
                [
                    // {text: 'Ask me later', onPress: () => {}},
                    // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                    {
                        text: i18n.t('constant.ok'), onPress: () => {
                        }
                    },
                ],
                {cancelable: true}
            )
        } else {
            if (LastName.value.trim().length <= 1) {
                HMAlert(
                    i18n.t('constant.message'),
                    i18n.t('constant.MustContainOneCharacter'),
                    [
                        // {text: 'Ask me later', onPress: () => {}},
                        // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                        {
                            text: i18n.t('constant.ok'), onPress: () => {
                            }
                        },
                    ],
                    {cancelable: true}
                )
                //alert('حداقل باید ۱۰ کاراکتر باشد')

            } else {
                this.setState({once: true});
                //  this.loadingButton.showLoading(true);
                this.getData();
            }
        }


    }

    _changeTextFirstName(text) {
        this.setState({
            FirstName: {
                value: text,
                error: ''
            }
        });
    }

    _changeTextLastName(text) {
        this.setState({
            LastName: {
                value: text,
                error: ''
            }
        });
    }

    _checkDisplay(field) {
        return {display: field === '' ? 'none' : 'flex'}
    }

    render() {
        const FirstNameError = this.state.FirstName.error;
        const LastNameError = this.state.LastName.error;
        return (
            <View style={{position: 'relative', flex: 1}}>
                {/*<HMImageBackground/>*/}
                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <View style={{flex: 1,}}>
                            <HMActionBarSatia
                                props={this.props} statusBarTransparent
                                //  text={i18n.t('ChangeInformation.title')}
                                text={"مشاهده اطلاعات"}

                                //  text={i18n.t('constant.Information')}

                                menu
                                back
                                headerVisibility more_menu
                                onBackPress={() => this.props.navigation.pop()}

                            />
                            <ScrollView>
                                <View style={{
                                    backgroundColor: Colors.white,
                                    borderWidth: moderateScale(1),
                                    borderColor: Colors.light,
                                    borderRadius: moderateScale(6),
                                    margin: moderateScale(10),
                                    overflow: 'hidden',
                                    paddingBottom: moderateScale(10)
                                }}>


                                    <View style={{flexDirection: 'row', width: "96%", alignSelf: 'center'}}>

                                        <View style={{flex: .5}}>
                                            <HMTextInputEfects
                                                _ref={scroll => this["inputphone"] = scroll}
                                                editable={false}

                                                refName={"phone"}

                                                type={"CostumeFumi"}
                                                value={this.state.phone}

                                                label={i18n.t('constant.phone')}
                                                onChangeText={text => this.setState({
                                                    phone: text
                                                })}
                                                iconClass={FontAwesomeIcon}
                                                iconName={'phone'}
                                                // keyboardType={'number-pad'}
                                                // _scroll={this._scroll}

                                                // secureTextEntry={true}
                                                onSubmitEditing={() => this._focusNextField("inputPlaceDispatchInjured")}

                                                containerStyle={{}}
                                                containerInputStyle={{
                                                    backgroundColor: Colors.transparent,
                                                    borderWidth: moderateScale(1),

                                                    borderRadius: moderateScale(10),
                                                    // overflow: 'hidden',
                                                    marginVertical: moderateScale(4)
                                                }}
                                                border={true}

                                            />
                                        </View>
                                        <View style={{flex: .5}}>
                                            <HMTextInputEfects
                                                _ref={scroll => this["inputphoneNumber"] = scroll}
                                                editable={false}

                                                refName={"phoneNumber"}

                                                type={"CostumeFumi"}
                                                value={this.state.phoneNumber}

                                                label={i18n.t('constant.phoneNumber')}
                                                onChangeText={text => this.setState({
                                                    phoneNumber: text
                                                })}
                                                iconClass={FontAwesomeIcon}
                                                iconName={'phone'}
                                                // keyboardType={'number-pad'}
                                                // _scroll={this._scroll}

                                                // secureTextEntry={true}
                                                onSubmitEditing={() => {
                                                }}

                                                containerStyle={{}}
                                                containerInputStyle={{
                                                    backgroundColor: Colors.transparent,
                                                    borderWidth: moderateScale(1),

                                                    borderRadius: moderateScale(10),
                                                    // overflow: 'hidden',
                                                    marginVertical: moderateScale(4)
                                                }}
                                                border={true}

                                            />
                                        </View>

                                    </View>
                                    <View style={{flexDirection: 'row', width: '94%', alignSelf: 'center'}}>

                                        {/*     <View
                                        style={{
                                            flexDirection: 'row', flex: .53,
                                            //width: "96%",
                                            //  alignSelf: 'center',
                                            alignItems: 'center',
                                            marginVertical: moderateScale(3)
                                        }}>
                                        <HMTextView
                                            //  numberOfLines={1}
                                            // type={'bold'}
                                            text={i18n.t('constant.type') + " : "}
                                            // text={"در دو هفته اخیر با چند نفر در ارتباط بودید؟"}
                                            style={{
                                                //marginTop: moderateScale(18),
                                                marginHorizontal: moderateScale(4),
                                                color: Colors.blackLight,
                                                // marginEnd: moderateScale(10),
                                                fontSize: moderateScale(14),
                                                textAlign: 'center',
                                                //  marginHorizontal: moderateScale(8)

                                            }}/>


                                        <HMListCheckBox
                                            data={{
                                                list: [
                                                    {id: 1, name: i18n.t('constant.Injury')},
                                                    {id: 2, name: i18n.t('constant.Death')},

                                                ],

                                                indexSelect: this.state['indexSelectCheckBoxHealthType'],
                                                name: 'HealthType',

                                            }}
                                            onPress={this.onPressSelectCheckBox
                                            }

                                        />
                                    </View>*/}
                                        <View
                                            style={{
                                                flexDirection: 'row',
                                                // backgroundColor: "#ee005c",

                                                flex: 1,
                                                // backgroundColor: "#8feeeb",

                                                //width: "96%",
                                                //alignSelf: 'center',
                                                alignItems: 'center',
                                                marginVertical: moderateScale(3)
                                            }}>
                                            <HMTextView
                                                //  numberOfLines={1}
                                                // type={'bold'}
                                                text={i18n.t('constant.Gender') + " : "}
                                                // text={"در دو هفته اخیر با چند نفر در ارتباط بودید؟"}
                                                style={{
                                                    //marginTop: moderateScale(18),
                                                    marginHorizontal: moderateScale(4),
                                                    color: Colors.blackLight,
                                                    // marginEnd: moderateScale(10),
                                                    fontSize: moderateScale(14),
                                                    textAlign: 'center',
                                                    //  marginHorizontal: moderateScale(8)

                                                }}/>


                                            <HMListCheckBox
                                                data={{
                                                    list: this.state.indexSelectCheckBoxGender === 1 ? [
                                                            {id: 1, name: i18n.t('constant.Man')},

                                                        ] :
                                                        [
                                                            {id: 2, name: i18n.t('constant.Woman')},

                                                        ]
                                                    ,
                                                    indexSelect: this.state['indexSelectCheckBoxGender'],
                                                    name: 'Gender',

                                                }}
                                                onPress={this.onPressSelectCheckBox
                                                }

                                            />
                                        </View>
                                    </View>
                                    <View style={{flexDirection: 'row', width: "96%", alignSelf: 'center'}}>

                                        <View style={{flex: .5}}>
                                            <HMTextInputEfects
                                                _ref={scroll => this["inputFirst_name"] = scroll}
                                                editable={false}


                                                refName={"First_name"}

                                                type={"CostumeFumi"}
                                                value={this.state.First_name}

                                                label={i18n.t('constant.First_name')}
                                                onChangeText={text => this.setState({
                                                    First_name: text
                                                })}
                                                iconClass={FontAwesomeIcon}
                                                iconName={'phone'}
                                                //keyboardType={'number-pad'}
                                                // _scroll={this._scroll}

                                                // secureTextEntry={true}
                                                onSubmitEditing={() => this._focusNextField("inputLast_name")}
                                                containerStyle={{}}
                                                containerInputStyle={{
                                                    borderWidth: moderateScale(1),

                                                    borderRadius: moderateScale(10),
                                                    // overflow: 'hidden',
                                                    marginVertical: moderateScale(4)
                                                }}
                                                border={true}

                                            />
                                        </View>
                                        <View style={{flex: .5}}>
                                            <HMTextInputEfects
                                                _ref={scroll => this["inputLast_name"] = scroll}
                                                editable={false}

                                                refName={"Last_name"}

                                                type={"CostumeFumi"}
                                                value={this.state.Last_name}

                                                label={i18n.t('constant.Last_name')}
                                                onChangeText={text => this.setState({
                                                    Last_name: text
                                                })}
                                                iconClass={FontAwesomeIcon}
                                                iconName={'phone'}
                                                //keyboardType={'number-pad'}
                                                // _scroll={this._scroll}

                                                // secureTextEntry={true}
                                                onSubmitEditing={() => this._focusNextField("inputAge")}
                                                containerStyle={{}}
                                                containerInputStyle={{
                                                    borderWidth: moderateScale(1),

                                                    borderRadius: moderateScale(10),
                                                    // overflow: 'hidden',
                                                    marginVertical: moderateScale(4)
                                                }}
                                                border={true}

                                            />
                                        </View>

                                    </View>

                                    <View style={{flexDirection: 'row', width: "96%", alignSelf: 'center'}}>

                                        <View style={{flex: .5}}>
                                            <HMTextInputEfects
                                                _ref={scroll => this["inputNationalCode"] = scroll}
                                                editable={false}

                                                refName={"NationalCode"}

                                                type={"CostumeFumi"}
                                                value={this.state.NationalCode}

                                                label={i18n.t('constant.NationalCode')}
                                                onChangeText={text => this.setState({
                                                    NationalCode: text
                                                })}
                                                iconClass={FontAwesomeIcon}
                                                iconName={'phone'}
                                                keyboardType={'number-pad'}
                                                // _scroll={this._scroll}

                                                // secureTextEntry={true}
                                                onSubmitEditing={() => this._focusNextField("inputJob")}
                                                containerStyle={{}}
                                                containerInputStyle={{
                                                    borderWidth: moderateScale(1),

                                                    borderRadius: moderateScale(10),
                                                    // overflow: 'hidden',
                                                    marginVertical: moderateScale(4)
                                                }}
                                                border={true}

                                            />
                                        </View>
                                        <View style={{flex: .5}}>
                                            <HMTextInputEfects
                                                _ref={scroll => this["inputEducation"] = scroll}
                                                editable={false}

                                                refName={"Education"}

                                                type={"CostumeFumi"}
                                                value={this.state.Education}

                                                label={i18n.t('constant.Education')}
                                                onChangeText={text => this.setState({
                                                    Education: text
                                                })}
                                                iconClass={FontAwesomeIcon}
                                                iconName={'phone'}
                                                //   keyboardType={'number-pad'}
                                                // _scroll={this._scroll}

                                                // secureTextEntry={true}
                                                onSubmitEditing={() => this._focusNextField("inputNationalCode")}
                                                containerStyle={{}}
                                                containerInputStyle={{
                                                    borderWidth: moderateScale(1),

                                                    borderRadius: moderateScale(10),
                                                    // overflow: 'hidden',
                                                    marginVertical: moderateScale(4)
                                                }}
                                                border={true}

                                            />
                                        </View>

                                    </View>
                                    <View style={{flexDirection: 'row', width: "96%", alignSelf: 'center'}}>

                                        <View style={{flex: .5}}>
                                            <HMTextInputEfects
                                                _ref={scroll => this["inputEmail"] = scroll}
                                                editable={false}

                                                refName={"Email"}

                                                type={"CostumeFumi"}
                                                value={this.state.Email}

                                                label={i18n.t('constant.Email')}
                                                onChangeText={text => this.setState({
                                                    Email: text
                                                })}
                                                iconClass={FontAwesomeIcon}
                                                iconName={'phone'}
                                                // keyboardType={'number-pad'}
                                                // _scroll={this._scroll}

                                                // secureTextEntry={true}
                                                onSubmitEditing={() => this._focusNextField("inputPlaceDispatchInjured")}

                                                containerStyle={{}}
                                                containerInputStyle={{
                                                    borderWidth: moderateScale(1),

                                                    borderRadius: moderateScale(10),
                                                    // overflow: 'hidden',
                                                    marginVertical: moderateScale(4)
                                                }}
                                                border={true}

                                            />
                                        </View>
                                        <View style={{flex: .5}}>
                                            <HMTextInputEfects
                                                _ref={scroll => this["inputPostalCode"] = scroll}
                                                editable={false}

                                                refName={"PostalCode"}

                                                type={"CostumeFumi"}
                                                value={this.state.PostalCode}

                                                label={i18n.t('constant.PostalCode')}
                                                onChangeText={text => this.setState({
                                                    PostalCode: text
                                                })}
                                                iconClass={FontAwesomeIcon}
                                                iconName={'phone'}
                                                // keyboardType={'number-pad'}
                                                // _scroll={this._scroll}

                                                // secureTextEntry={true}
                                                onSubmitEditing={() => {
                                                }}

                                                containerStyle={{}}
                                                containerInputStyle={{
                                                    borderWidth: moderateScale(1),

                                                    borderRadius: moderateScale(10),
                                                    // overflow: 'hidden',
                                                    marginVertical: moderateScale(4)
                                                }}
                                                border={true}

                                            />
                                        </View>

                                    </View>
                                    <HMTextInputEfects
                                        _ref={scroll => this["inputaddress"] = scroll}
                                        editable={false}

                                        refName={"address"}

                                        type={"CostumeFumi"}
                                        value={this.state.address}

                                        label={i18n.t('constant.address')}
                                        onChangeText={text => this.setState({
                                            address: text
                                        })}
                                        iconClass={FontAwesomeIcon}
                                        iconName={'phone'}
                                        // keyboardType={'number-pad'}
                                        // _scroll={this._scroll}

                                        // secureTextEntry={true}
                                        onSubmitEditing={() => {
                                        }}
                                        height={moderateScale(100)}
                                        multiline={true}

                                        containerStyle={{}}
                                        containerInputStyle={{
                                            borderWidth: moderateScale(1),

                                            borderRadius: moderateScale(10),
                                            // overflow: 'hidden',
                                            marginVertical: moderateScale(4)
                                        }}
                                        border={true}

                                    />

                                    {/*    <TouchableOpacity style={{
                                        backgroundColor: Colors.colorPrimary,
                                        width: "85%",
                                        height: moderateScale(40),
                                        alignItems: "center",
                                        justifyContent: "center",
                                        alignSelf: 'center',
                                        marginTop: moderateScale(14),
                                        borderRadius: moderateScale(6),
                                        marginEnd: moderateScale(10),
                                        //  marginHorizontal:moderateScale(10)
                                        // borderRadius:moderateScale(2)
                                    }}
                                                      onPress={() => {
                                                          this.checkInput()
                                                      }}

                                    >
                                        <View style={{
                                            flexDirection: "row",
                                            alignItems: "center",
                                            justifyContent: "center"
                                        }}>
                                            <HMTextView type={"bold"} text={i18n.t('constant.Edit')} style={{
                                                color: "white",
                                                fontSize: moderateScale(16),
                                                //   marginEnd: moderateScale(10),

                                            }}/>

                                        </View>
                                    </TouchableOpacity>*/}
                                </View>
                            </ScrollView>


                            {
                                this.props.NoInternetDialog ?
                                    <DialogConnectionCustomize
                                        again
                                        onPress={() => {
                                            // this.loadingButton.showLoading(false),
                                            this.props.callserviceActionRefresh()
                                        }}
                                    />
                                    :
                                    null
                            }
                            {
                                this.props.isLoading ?
                                    <DialogLoadingCustomize/>
                                    : null
                            }
                        </View>
                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }

    onPressSelectCheckBox(item, name, check) {
        container.setState({
            //    ['indexSelectCheckBox' + name]: check ? null : item.id
            },
            () => {
            })
    }
}
